import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { DefaultButton } from 'components/button/DefaultButton';
import { ComponentType } from 'react';
import { FallbackProps } from 'react-error-boundary';

import { ErrorContainer, ErrorDetails, ErrorIcon, ErrorTitle } from './styled';

export type DefaultErrorFallbackProps = FallbackProps &
    Readonly<{
        'test-id'?: string;
    }>;

/**
 * Default fallback component shown when no custom fallback is provided.
 * Follows the EmptyState pattern for consistent UX.
 * Shows error details only in development mode for security.
 */
export const DefaultErrorFallback: ComponentType<DefaultErrorFallbackProps> = ({
    error,
    resetErrorBoundary,
    'test-id': testId,
}) => {
    const baseTestId = testId || 'error-boundary';

    return (
        <ErrorContainer role="alert" data-testid={baseTestId}>
            <ErrorIcon icon={faExclamationTriangle} aria-hidden="true" />
            <ErrorTitle>Something went wrong</ErrorTitle>
            <DefaultButton
                onClick={resetErrorBoundary}
                data-testid={`${baseTestId}-reset-button`}
            >
                Try again
            </DefaultButton>
            {process.env.NODE_ENV === 'development' && (
                <ErrorDetails data-testid={`${baseTestId}-error-details`}>
                    <summary>View error details</summary>
                    <pre>{error?.toString()}</pre>
                </ErrorDetails>
            )}
        </ErrorContainer>
    );
};
